import React from "react";
import { Link } from "react-router-dom";
import "../styles/Footer.css";
import { T } from './Translation';

function Footer() {
  return (
    <footer className="footer-section">
      <div className="footer-top">
        <div className="footer-brand">Invitly</div>
        <div className="footer-links">
          <a href="#hero"><T k="home" /></a>
          <a href="#pricing"><T k="pricing" /></a>
          <Link to="/privacy-policy"><T k="footerPrivacy" /></Link>
          <a href="#faq"><T k="footerTerms" /></a>
        </div>
      </div>
      <div className="footer-bottom">
        <p><T k="footerRights" /></p>
      </div>
    </footer>
  );
}

export default Footer;
